<template>
  <fragment>
    <t-dialog ref="dialog" dense light :fullscreen="$forSize['phone-only']" :persistent="persistent">
      <template v-slot:title>
        <span v-html="$config.strings['s018']" />
      </template>
      <template v-slot:text>
        <div class="cadastro-dialog-header">
          <div
            class="cadastro-dialog-mensagem-bem-vindo"
            :style="fadeIn('BEM_VINDO')"
          />
          <div class="cadastro-dialog-radio-group-container">
            <div
              v-if="step === 'cadastro'"
              class="cadastro-dialog-right-title"
              v-html="$config.strings['cadastre-se-gratis']"
            />
          </div>
        </div>
        <div v-if="step === 'cadastro'" class="cadastro-observacao" v-html="$config.strings['cadastro-observacao']"/>
        <form
          class="form-cadastro"
          v-if="step === 'cadastro'"
          action="javascript:;"
          @submit="handleCadastro"
        >
          <t-input
            id="input-nome"
            v-model="nome"
            :label="$config.strings['label-nome']"
            :error="errors.nome"
            @input="resetarErro('nome')"
          />
          <t-input
            :error="errors.cpf"
            label="CPF"
            class="cpf-input"
            v-mask="'###.###.###-##'"
            placeholder="000.000.000-00"
            v-model="cpf"
            @input="resetarErro('cpf')"
          />
          <t-input
            id="input-email"
            v-model="email"
            :label="$config.strings['label-email']"
            type="email"
            :error="errors.email"
            @input="resetarErro('email')"
          />
          <t-button
            :backgroundColor="$config.colors.secondary"
            :color="$config.colors.on.secondary"
            v-html="$config.strings['cadastrar']"
          />
        </form>
        <div class="dialog-cadastro-success" v-else-if="step === 'sucesso'">
          <p class="dialog-cadastro-success-message" v-html="$config.strings['dialog-cadastro-success-message']"/>
          <t-button
            class="dialog-cadastro-success-btn"
            @click="() => { step = 'info' }"
            :backgroundColor="$config.colors.secondary"
            :color="$config.colors.on.secondary"
            v-html="$config.strings['dialog-cadastro-success-btn']"
          />
        </div>
        <div class="dialog-cadastro-login-info" v-else-if="step === 'info'">
          <div
            class="primeiro-acesso-img"
            :style="fadeIn('PASSO_DE_ACESSO')"
          />
          <t-button
            class="dialog-cadastro-login-info-btn"
            @click="() => { $refs.dialog.close() }"
            :backgroundColor="$config.colors.secondary"
            :color="$config.colors.on.secondary"
            v-html="$config.strings['dialog-cadastro-login-info-btn']"
          />
        </div>
      </template>
    </t-dialog>
    <t-dialog ref="errorDialog">
      <template v-slot:title>
        <span v-html="$config.strings['dialog-error-title']" />
      </template>
      <template v-slot:text>
        {{ apiError }}
      </template>
    </t-dialog>
    <t-loading :visible="loading" />
  </fragment>
</template>

<script>
import {
  TDialog,
  TInput,
  TButton,
  TLoading
} from '@/components/base'
import { mask } from 'vue-the-mask'
import WaitImagesLoad from '@/mixins/wait-images-load'
import isValidCpf from '@/utils/is-valid-cpf'
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'dialog-cadastro',
  mixins: [WaitImagesLoad],
  directives: { mask },

  data: () => ({
    loading: false,
    step: 'cadastro',
    nome_: '',
    email_: '',
    cpf_: '',
    apiError: '',
    errors: {
      nome: '',
      email: '',
      cpf: ''
    },
    codigoExterno: ''
  }),
  mounted () {
    this.$events.$on('OPEN_CADASTRO_DIALOG', () => {
      this.$refs.dialog.open()
      this.step = 'cadastro'
      this.codigoExterno = (new URLSearchParams(window.location.search)).get('polo') || ''
    })
  },
  beforeDestroy () {
    this.$events.$off('OPEN_CADASTRO_DIALOG')
  },
  computed: {
    persistent () {
      return this.step === 'info'
    },
    nome: {
      get () {
        return this.nome_.trim()
      },
      set (val) {
        this.nome_ = val
      }
    },
    cpf: {
      get () {
        return this.cpf_.trim()
      },
      set (val) {
        this.cpf_ = val
      }
    },
    email: {
      get () {
        return this.email_.trim()
      },
      set (val) {
        this.email_ = val
      }
    },
    images () {
      return {
        BEM_VINDO: this.$config.images['BEM_VINDO'],
        PASSO_DE_ACESSO: this.$config.images['PASSO_DE_ACESSO']
      }
    }
  },
  components: { TDialog, TInput, TButton, TLoading },
  methods: {
    ...mapActions(['cadastrar']),
    validate () {
      let isValid = true
      const validations = {
        nome: [
          (v) => isEmpty(v) && this.$config.strings['err-nome-vazio'],
          (v) =>
            !/^([a-zA-Z\u00C0-\u017F\s]{3,})$/.test(v) &&
            this.$config.strings['err-nome-invalido']
        ],
        cpf: [
          (v) => isEmpty(v) && this.$config.strings['err-cpf-vazio'],
          (v) => !isValidCpf(v) && this.$config.strings['err-cpf-invalido']
        ],
        email: [(v) => isEmpty(v) && this.$config.strings['err-email-vazio']]
      }
      Object.keys(validations).forEach((field) => {
        validations[field].every((isInvalid) => {
          const error = isInvalid(this[field])
          if (error) {
            this.$set(this.errors, field, error)
            isValid = false
            return false
          }
          return true
        })
      })
      return isValid
    },
    resetarErro (key) {
      this.$set(this.errors, key, '')
    },
    handleCadastro () {
      if (this.validate()) {
        this.loading = true
        this.cadastrar({
          nome: this.nome,
          cpf: this.cpf,
          email: this.email,
          linkAcesso: this.$config.urls['login_url'],
          codigoExterno: this.codigoExterno
        })
          .then(() => {
            this.nome = ''
            this.cpf = ''
            this.email = ''
            this.checked = 'ja-cadastrado'
            this.step = 'sucesso'
          })
          .catch((e) => {
            if (e.response && e.response.data && e.response.data.message) {
              this.apiError = e.response.data.message
              this.$refs.errorDialog.open()
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-cadastro-login-info {
  text-align: center;
  .dialog-cadastro-login-info-btn {
    margin: 30px 0;
  }
}
.dialog-cadastro-success {
  min-height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &-message {
    font: normal 40px/34px 'Open Sans';
    color: var(--primary);
    margin-top: 50px;
  }
  &-btn {
    margin: 100px 0;
  }
}
.cadastro-observacao {
  max-width: 700px;
  font: normal 18px/25px 'Open Sans';
  margin: 15px 30px;
  background-color: var(--surface);
  color: var(--on-surface);
}
.form-cadastro {
  padding: 15px;
  background-color: var(--background);
}
.cadastro-dialog-header {
  display: flex;
  width: 100%;
  max-width: 700px;
  justify-content: center;
}
.cadastro-dialog-mensagem-bem-vindo {
  width: 370px;
  height: 132px;
  margin-right: 15px;
  margin-left: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top right;
}
.cadastro-dialog-radio-group-container {
  margin-left: 15px;
  margin-right: 30px;
  margin-bottom: 15px;
}

.cadastro-dialog-right-title {
  margin-bottom: 30px;
  font: normal 28px/30px 'Open Sans';
  ::v-deep b {
    font: bold 28px/30px 'Open Sans';
  }
}

.primeiro-acesso-img {
  height: 100%;
  background-color: var(--background);
  background-size: contain;
  background-repeat: no-repeat;
  height: 657px;
  background-position: top center;
  width: 100%;
}
</style>
